<template>
    <div class="group-email">
        <heading title="Group Email"></heading>
        <b-overlay :show="sending">
            <b-row>
                <b-overlay :show="addingGroup" class="col-12 col-lg-8">
                    <b-card-header>
                        <h3>Select Recipients</h3>
                        <b-btn variant="success" @click="addGroup()">
                            Add All
                            <b-icon-plus-circle/>
                        </b-btn>
                    </b-card-header>
                    <b-card-body>

                        <data-table ref="dataTable"
                                    :show-filters="true"
                                    :show-pager="true"
                                    :get-items="getUsers"
                                    v-model="filters"
                                    :fields="fields"
                                    @select-item-selected="selectFilterChanged">
                            <template v-slot:customField="slotProps">
                                <template v-if="slotProps.row.field.key === 'last_name'">
                                    <user-details :user="slotProps.row.item"/>
                                </template>
                                <template v-if="slotProps.row.field.key === 'agency_names'">
                                    {{ getNames(slotProps.row.item.agency_names) }}
                                </template>
                                <template v-else-if="slotProps.row.field.key === 'company_names'">
                                    {{ getNames(slotProps.row.item.company_names) }}
                                </template>
                                <template v-else-if="slotProps.row.field.key === 'status'">
                                    {{ getStatusLabel(slotProps.row.item.status) }}
                                </template>
                                <template v-else-if="slotProps.row.field.key === 'role'">
                                    <user-role-badge :user="slotProps.row.item"/>
                                </template>
                                <template v-else-if="slotProps.row.field.key === 'approved'">
                                    <b-badge :variant="slotProps.row.item.approved ? 'success' : 'danger'">
                                        {{ slotProps.row.item.approved ? 'True' : 'False' }}
                                    </b-badge>
                                </template>
                                <template v-else-if="slotProps.row.field.key === 'add'">
                                    <b-btn variant="success" size="sm" class="recipient-btn"  @click="addRecipient(slotProps.row.item)">
                                        <b-icon-plus-circle class="ml-0"/>
                                    </b-btn>
                                </template>
                                <div v-else-if="slotProps.row.field.key === 'email'">
                                    {{ slotProps.row.item.email }}
                                </div>
                            </template>
                        </data-table>
                    </b-card-body>
                </b-overlay>

                <div class="col-12 col-lg-4">
                    <b-card-header>
                        <h3>Message</h3>
                    </b-card-header>
                    <b-card-body class="message-form">
                        <strong>Recipients</strong>
                        <div class="form-group">
                            <em v-if="recipients.length === 0 && recipientGroups.length === 0">No Recipients Selected</em>
                            <b-row v-for="(rec, i) in recipients" class="mx-0 pb-1" :key="i">
                                <user-details :user="rec"/>
                                <b-btn variant="danger" @click="removeRecipient(i)" class="recipient-btn" size="sm">
                                    <b-icon-x-circle class="ml-0"/>
                                </b-btn>
                            </b-row>
                            <b-row v-for="(rec, j) in recipientGroups" class="mx-0 pb-1" :key="j">
                                <span class="badge" style="background-color: #343a40; margin: 5px;">{{rec.groupName}} : {{rec.count}} users</span>
                                <b-btn variant="danger" @click="removeRecipientGroup(j)" class="recipient-btn ml-1" size="sm">
                                    <b-icon-x-circle class="ml-0"/>
                                </b-btn>
                            </b-row>
                        </div>
                        <b-form-group label="Subject">
                            <b-form-input v-model="subject"/>
                        </b-form-group>
                        <b-form-group label="Message">
                            <vue-trix v-model="message"/>
                        </b-form-group>
                    </b-card-body>
                    <div class="pt-3 d-flex justify-content-center">
                        <b-btn :disabled="!valid" @click="onSubmit" class="btn-primary">
                            Send Email
                            <b-icon-envelope class="ml-1"/>
                        </b-btn>
                    </div>

                </div>

            </b-row>


        </b-overlay>
    </div>
</template>

<script>

import UserDetails from "@/components/UserDetails.vue";
import User from "@/models/User";
import Agency from "@/models/Agency";
import Company from "@/models/Company";
import * as _ from 'lodash';
import Api from "@/providers/Api";

export default {
    name: "GroupEmail",
    components: {UserDetails},
    data () {
        return {
            subject: '',
            message: '',
            recipients: [],
            recipientGroups: [],
            addingGroup: false,
            sending: false,
        }
    },
    methods: {
        getUsers (listParams) {
            return this.$api.getItems(this, 'user', this.filters, listParams, ['agency_names', 'company_names'])
        },
        getName (item) {
            return item ? item.name : ''
        },
        getNames (value) {
            return value ? _.truncate(_.map(value, (el) => this.getName(el)).join(', ')) : null
        },
        getStatusLabel (value) {
            return User.getStatusLabel(value)
        },
        getRoleLabel (value) {
            return User.getRoleLabel(value)
        },
        async onSubmit() {
            this.sending = true
            const recEmails = _.map(this.recipients, (rec) => rec.email)
            _.forEach(this.recipientGroups, (recGroup) => {
                recEmails.push(...recGroup.emails)
            })
            await this.$api.sendGroupEmail(this, {body: this.message, subject: this.subject, recipients: recEmails})
            this.subject =  ''
            this.message = ''
            this.recipients = []
            this.recipientGroups = []
            this.sending = false
            this.$toasted.success('Emails Sent')
        },
        addRecipient(item) {
            this.recipients.push(item)
        },
        async addGroup() {
            this.addingGroup = true
            const all = this.$api.getItems(this, 'user', this.filters, {perPage: null}, ['agency_names', 'company_names'])
            const allEmails = _.map(await all, (user) => user.email)
            this.recipientGroups.push({emails: allEmails, count: allEmails.length, groupName: await this.groupName()})
            this.addingGroup = false
        },
        removeRecipient(index) {
            this.recipients.splice(index, 1)
        },
        removeRecipientGroup(index) {
            this.recipientGroups.splice(index, 1)
        },

        selectFilterChanged (field, item) {
            if (field === 'agency_id') {
                this.filterAgencyName = item ? item.text : null
            }
        },
        async groupName() {
            let name = ''
            if (this.filters.agency_id.value) {
                name += await Agency.getAgencyName(this.filters.agency_id.value) + ' '
            }
            if (this.filters.company_id.value) {
                name += await Company.getCompanyName(this.filters.company_id.value) + ' '
            }
            if (this.filters.role.value) {
                name += User.getRoleLabel(this.filters.role.value) + 's'
            }
            if (name === '') {
                return 'Group'
            }
            return name
        },
    },
    computed: {
        valid() {
            if (!this.subject || this.subject === '') {
                return false
            }
            if (!this.message || this.message === '') {
                return false
            }
            if (!this.recipients || this.recipients.count === 0) {
                return false
            }
            return true
        },
        agencyFilter () {
            if (this.userCompanyId || this.companyId || this.$user.isProjectManager()) {
                return null
            } else {
                return {
                    field: 'agency_id',
                    type: 'select',
                    label: 'Agency',
                    apiTable: 'agency',
                    labelField: 'name',
                    defaultValue: this.agencyId, // from props
                }
            }
        },
        companyFilter () {
            if (this.userCompanyId) { // equipment owner
                return {
                    field: 'company_id',
                    type: 'hidden',
                    value: this.userCompanyId, // from user
                }
            } else {
                return {
                    field: 'company_id',
                    type: 'multiselect',
                    search: (query) => {
                        return Api.getItems(this, 'company', { name: { field: 'name', value: query } })
                    },
                    label: 'Company',
                    apiTable: 'company',
                    labelField: 'name',
                    defaultValue: this.companyId // from props
                }
            }
        },
        roleFilter () {
            if (this.$user.isAdmin() || this.$user.isSuperAdmin()) {
                const roleLabels = User.getRoleLabels()
                return {
                    field: 'role',
                    type: 'select',
                    options: _.map(_.keys(roleLabels), (key) => {
                        return {value: key, text: roleLabels[key]}
                    }),
                    label: 'Role',
                }
            } else {
                return null
            }
        },
        filters: {
            get () {
                const filters = {
                    email: { field: 'email', type: 'string', value: null, label: 'Email' },
                    first_name: { field: 'first_name', type: 'string', value: null, label: 'First Name' },
                    last_name: { field: 'last_name', type: 'string', value: null, label: 'Last Name' },
                }
                if (this.roleFilter) {
                    filters.role = this.roleFilter
                }
                if (this.agencyFilter) {
                    filters.agency_id = this.agencyFilter
                }
                if (this.companyFilter) {
                    filters.company_id = this.companyFilter
                }
                return filters
            },
            set (val) {}
        },
        fields () {
            let fields = [
                { key: 'last_name', sortable: true, label: 'Name' },
                { key: 'role', sortable: true, label: 'Role' },
            ]
            if (!this.companyId) {
                fields.push({ key: 'agency_names', label: 'Agency' })
            }
            fields = fields.concat([
                { key: 'company_names', label: 'Company' },
                { key: 'last_name', sortable: true, label: 'Last Name' },
                { key: 'email', sortable: true, label: 'Email' },
                { key: 'approved', sortable: false, label: 'Approved' },
                { key: 'add', sortable: false, label: 'Add'}
            ])
            return fields
        },
    }
}
</script>

<style lang="scss">

.group-email {
    trix-editor {
        display: inline-block;
        height: 40vh;
        width: 100%
    }
    .recipient-btn {
        padding: .4rem .75rem;
        align-self: center;
    }
    .message-form {
        min-height: 62vh;
        .col-form-label {
            font-weight: bold;
        }
    }
}
</style>